<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.72 8.25">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          d="M10,.08l.66.67a.27.27,0,0,1,0,.39l-7,7a.28.28,0,0,1-.4,0L.08,5a.27.27,0,0,1,0-.39L.74,4a.28.28,0,0,1,.4,0L3.41,6.25,9.57.08A.28.28,0,0,1,10,.08Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
